import { useNavigate, useLocation } from "react-router-dom";
import { useCompare } from "@/contexts/CompareContext";
import { Button } from "@/components/ui/button";
import { GitCompareArrows, X } from "lucide-react";

export const CompareBar = () => {
  const { ids, clear } = useCompare();
  const navigate = useNavigate();
  const location = useLocation();
  if (ids.length === 0 || location.pathname === "/compare") return null;
  return (
    <div
      data-testid="compare-bar"
      className="fixed bottom-5 left-1/2 -translate-x-1/2 z-40 bg-[#1A1A1A] text-white rounded-full shadow-2xl px-2 py-1.5 flex items-center gap-2 animate-in fade-in slide-in-from-bottom-4"
    >
      <span className="text-xs px-3 font-medium tabular-nums">
        {ids.length} sélectionné{ids.length > 1 ? "s" : ""}
      </span>
      <Button
        size="sm"
        onClick={() => navigate("/compare")}
        data-testid="compare-bar-open"
        className="rounded-full bg-[#D6202C] hover:bg-[#B5181F] h-9"
      >
        <GitCompareArrows className="w-4 h-4 me-1" /> Comparer
      </Button>
      <button
        onClick={clear}
        className="w-8 h-8 rounded-full hover:bg-white/10 flex items-center justify-center"
        aria-label="Vider"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
